import { Alert, Button, Loader, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router';
import { useSession } from '@/api/session';
import { useAcceptInvitation, useInvitation } from '@/api/workspace';
import { useApiError } from '@/hooks/useApiError';
import { AuthLayout } from './AuthLayout';

/** Einladung annehmen (TEAM-01): angemeldet direkt, sonst Registrierung/Login. */
export function InvitePage() {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const session = useSession();
  const invitation = useInvitation(token);
  const accept = useAcceptInvitation();
  const onError = useApiError();

  return (
    <AuthLayout>
      <Stack>
        <Title order={3} ta="center">
          {t('invite.title')}
        </Title>
        {invitation.isPending && <Loader mx="auto" />}
        {invitation.isError && <Alert color="red">{t('invite.invalid')}</Alert>}
        {invitation.data && (
          <>
            <Text ta="center">{t('invite.text', { workspace: invitation.data.workspaceName })}</Text>
            {session.data?.authenticated ? (
              <Button
                loading={accept.isPending}
                onClick={() => accept.mutate(token!, { onSuccess: () => navigate('/tracker'), onError })}
              >
                {t('invite.accept')}
              </Button>
            ) : (
              <>
                <Button component={Link} to={`/register?invitation=${token}`}>
                  {t('invite.createAccount')}
                </Button>
                <Button variant="default" component={Link} to="/login" state={{ from: `/invite/${token}` }}>
                  {t('invite.loginFirst')}
                </Button>
              </>
            )}
          </>
        )}
      </Stack>
    </AuthLayout>
  );
}
